export const ZERO_ADDRESS = '0x0000000000000000000000000000000000000000'

/** Empty calldata for transactions with no data */
export const EMPTY_DATA = '0x'

/** Linked-list sentinel address used in Safe modules (recovery, spending limits) */
export const SENTINEL_ADDRESS = '0x0000000000000000000000000000000000000001'
